/**
 * Cache keys for consumer transaction data — the single source of truth so the
 * query and the realtime invalidation can't drift.
 *
 * Keyed by the transaction's PUBLIC id (matching the SSE `transaction.updated`
 * event's `transactionId`), with the dealership slug as a trailing segment so an
 * `all(pId)` invalidation matches the cached query regardless of slug.
 */
export const transactionKeys = {
  all: (transactionPId: string) => ['transaction', transactionPId] as const,
  detail: (transactionPId: string, dealershipSlug: string) =>
    [...transactionKeys.all(transactionPId), dealershipSlug] as const
};
